<template>
  <nuxt-link
    :to="{ path: `/blog/${slug}` }"
    class="card-container is-flex is-flex-direction-column"
  >
    <div class="">
      <figure class="image">
        <!-- Decorative: the article title sits next to it as the link
             text, so repeating it here would double up for screen readers. -->
        <img
          :src="thumbnail"
          :srcset="thumbnailSrcset"
          sizes="(min-width: 769px) 300px, 92vw"
          alt=""
          loading="lazy"
          decoding="async"
        />
      </figure>
    </div>
    <div class="card-title px-5 py-5">
      {{ article.title }}
    </div>
    <div class="ps-button short is-outlined button read-more mb-5">
      Read more
    </div>
  </nuxt-link>
</template>

<script>
import { ghostImageSrcset, ghostImageUrl } from '@/helpers/ghost-image'

export default {
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    article: [],
  }),
  async fetch() {
    try {
      this.article = await this.$axios.$get(`/api/blog/v1/post/${this.slug}`)
    } catch (e) {
      console.log('ee', e)
    }
  },
  computed: {
    thumbnail() {
      return ghostImageUrl(this.article.feature_image, 600)
    },
    thumbnailSrcset() {
      return ghostImageSrcset(this.article.feature_image, [300, 600])
    },
  },
}
</script>

<style lang="scss" scoped>
.card-container {
  border-radius: $ps-radius-lg;
  overflow: hidden;
  background: $ps-canvas;
}
.image {
  min-width: 100%;

  img {
    display: block;
    width: 100%;
    height: auto;
    // Ghost's feature images for these posts are consistently 4:3 (checked
    // the three actual files: 600x450). Reserves space for the lazy-loaded
    // image before it scrolls into view, instead of a 0-height box.
    aspect-ratio: 4 / 3;
    object-fit: cover;
  }
}
.card-title {
  color: $ps-ink;
  height: 90px;
  text-align: center;
  font-size: $ps-text-body;
  font-weight: 600;
  line-height: 1.3;
  text-transform: lowercase;

  &:first-letter {
    text-transform: capitalize;
  }
}
.read-more {
  max-width: 100px;
  margin: 0 auto;
}
</style>
